// @ts-ignore
import type { ExtendedComponentSchema } from '@formio/angular';
import Component from '@formio/js/lib/cjs/components/_classes/component/Component';

import { DocumentType, FormioData } from './documents.model';

export interface FormioChangedEvent {
  changed: FormioComponentChanged;
}

export interface FormioComponentChanged {
  value: string;
  component: ExtendedComponentSchema;
  instance: FormioInstance;
}

export interface FormioInstance {
  parent?: FormioInstance;
  originalComponent: typeof Component;
  submission?: FormioSubmission;
}

export interface FormioValues {
  submission: FormioSubmission;
}

export interface FormioSubmissionData {
  [key: string]: any;
}

export interface FormioSubmission {
  data: FormioSubmissionData;
  metadata: FormioControlsData;
}

export interface FormioControlsData {
  controlsData: FormioControlData[];
}

export interface FormioControlData {
  formKey: string;
  controls: FormioOption[];
}

export interface FormioOption {
  key: string;
  value: any;
  label?: string;
}

export function newFormioData(data?: Partial<FormioData>): FormioData {
  return {
    formioForm: {},
    formioValues: newFormioValues(),
    ...data,
    documentType: DocumentType.Formio,
  };
}

export function newFormioValues(formioValues?: Partial<FormioValues>): FormioValues {
  return {
    submission: newFormioSubmission(),
    ...formioValues,
  };
}

export function newFormioSubmission(
  formioSubmission?: Partial<FormioSubmission>
): FormioSubmission {
  return {
    data: {},
    metadata: newFormioControlsData(),
    ...formioSubmission,
  };
}

export function newFormioControlsData(
  controlsData?: Partial<FormioControlsData>
): FormioControlsData {
  return {
    controlsData: [],
    ...controlsData,
  };
}

export function newFormioOption(formioOption?: Partial<FormioOption>): FormioOption {
  return {
    key: '',
    value: '',
    label: '',
    ...formioOption,
  };
}
